export const CREATE_TRANSACTION_START='CREATE_TRANSACTION_START';
export const CREATE_TRANSACTION_SUCCESS='CREATE_TRANSACTION_SUCCESS';
export const CREATE_TRANSACTION_FAIL='CREATE_TRANSACTION_FAIL';

export const TOGGLE_TRANSACTION_ADD_MODAL='TOGGLE_TRANSACTION_ADD_MODAL';